<span>
  @for (segment of segments; track $index) {
    @if (segment.url) {
      <a
        class="font-semibold text-green-700 underline underline-offset-2 hover:text-green-900 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-green-700"
        [href]="segment.url"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Open help link (opens in a new tab)">{{ segment.text }}</a>
    } @else {
      <span>{{ segment.text }}</span>
    }
  }
</span>
